module.exports = __webpack_public_path__ + "static/media/quote-frame-mobile.333adbcc.jpg";